export const PRIVILEGE = {
  editSettlementGroup: 10,
}

export const FIELD_ID = {
  bostonMatter: {
    groupNumber: 16469928,
    popSui: 16433261,
    implantProduct: 16433287,
    tkDeterm: 16433153,
    releaseFile: 16496521,
    relatedPlaintiff: 16517685,
    settlementGroup: 16390365,
    settlementAmount: 16496260,
    settlementStatus: 16496272,
    settleStatusOfferPending: 17498084,
    settleStatusFundsReleased: 17799344,
    dateDismissed: 16810409,
    caseStatus: 16809926,
    settlementFundReleaseDate: 19400050,
    dismissalType: 16810848,
    claimStatusPending: 16809930,
    claimStatusInactive: 31483298,
    dob: 16384257,
    ssn: 16474517,
    matrixType: 31544250,
    matrixTypeReason: 31544291,
  },
  caseCourt: {
    mdlDocketNumber: 16384275,
  },

}